import { reactive } from 'vue'

export type ToastType = 'success' | 'error' | 'info'

export interface ToastItem {
  id: number
  message: string
  type: ToastType
}

// Единый реактивный стек тостов. Рендерится глобально в ToastContainer (App.vue),
// показывается справа сверху. Лёгкий синглтон вместо Vuex — тосты эфемерны.
const state = reactive<{ items: ToastItem[] }>({ items: [] })
let seq = 0

export function useToasts(): { items: ToastItem[] } {
  return state
}

/**
 * Показать всплывающее уведомление о применённом действии.
 * @param message текст («Уведомления успешно отключены» и т.п.)
 * @param type    success | error | info (влияет на цвет)
 * @param durationMs через сколько скрыть автоматически (0 — не скрывать)
 */
export function showToast(message: string, type: ToastType = 'success', durationMs = 3000): number {
  const id = ++seq
  state.items.push({ id, message, type })
  if (durationMs > 0) {
    setTimeout(() => removeToast(id), durationMs)
  }
  return id
}

export function removeToast(id: number): void {
  const i = state.items.findIndex((t) => t.id === id)
  if (i !== -1) {
    state.items.splice(i, 1)
  }
}
